const { sentences } = require("./database");

const errorMessages = {
    131047 : 'Message failed to send because more than 24 hours have passed since the customer last replied to this number.',
    131053 : 'Message failed to send due to invalid media.',
};

const getInitials = function (string) {

    let initials = '';

    if(string !== undefined && string !== null){
        let names = string.split(' ');
        initials = names[0].substring(0, 1).toUpperCase();

        if (names.length > 1) {
            initials += names[names.length - 1].substring(0, 1).toUpperCase();
        }
    }

    return initials;
};

const getRandomSentence = () => {
	const randomIndex = Math.floor(Math.random() * sentences.length);
	const sentence = sentences[randomIndex];
	return sentence;
};

function getResponseInterval(min, max) {
	return Math.random() * (max - min) + min;
}

module.exports = { getRandomSentence, getResponseInterval, getInitials, errorMessages};